module.exports = __webpack_public_path__ + "static/media/arclabs_logo.a66c9f9a.png";